import { Box, withCitrusTheme, Color } from '@gousto-internal/citrus-react'

export const SectionPanel = withCitrusTheme(Box, (theme) => ({
  marginBottom: theme.spacing(4),
  paddingTop: theme.spacing(4),
  backgroundColor: theme.color(Color.White),
}))
